import {
  Avatar,
  colors,
  Divider,
  Drawer,
  Hidden,
  List,
  ListSubheader, Typography, Link, InputBase
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useOktaAuth } from '@okta/okta-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router';
import avatar from 'src/assets/images/technician.png';
import NavItem from 'src/components/NavItem';
import { getUser } from 'src/utils/Common';
import { isProduction } from 'src/utils/contants';
import { useTranslation } from 'react-i18next';

import axios from 'src/utils/axios';
import { Link as RouterLink } from 'react-router-dom';
import { sc } from 'src/utils/Common';
import { fade } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import NavConfig from './navConfig';


const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  navigation: {
    overflow: 'auto',
    padding: theme.spacing(0, 2, 2, 2),
    flexGrow: 1
  },
  profile: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  badge: {
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`
  },
  badgeDot: {
    height: 9,
    minWidth: 9
  },
  onlineBadge: {
    backgroundColor: colors.green[600]
  },
  awayBadge: {
    backgroundColor: colors.orange[600]
  },
  busyBadge: {
    backgroundColor: colors.red[600]
  },
  offlineBadge: {
    backgroundColor: colors.grey[300]
  },
  avatar: {
    cursor: 'pointer',
    width: 40,
    height: 40
  },
  details: {
    marginLeft: theme.spacing(2)
  },
  moreButton: {
    marginLeft: 'auto',
    color: colors.blueGrey[200]
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.55),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.65),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '20ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}));

function renderNavItems(
  {
    // eslint-disable-next-line react/prop-types
    items,
    subheader,
    key,
    ...rest
  },
  klima_teknisyeni
) {
  return (
    <List key={key}>
      {subheader && <ListSubheader disableSticky>{subheader}</ListSubheader>}
      {items.reduce(
        (acc, item) =>
          reduceChildRoutes({ acc, item, ...rest }, klima_teknisyeni),
        []
      )}
    </List>
  );
}

function reduceChildRoutes(
  { acc, pathname, item, depth = 0 },
  klima_teknisyeni
) {
  if (
    klima_teknisyeni &&
    item.klima_teknisyeni_gizle &&
    item.klima_teknisyeni_gizle
  ) {
    return acc;
  }
  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={item.href}
        label={item.label}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        key={item.href}
        label={item.label}
        title={item.title}
      />
    );
  }

  return acc;
}



const klima_teknisyeni = false;
function NavBar({ open, onClose, className, ...rest }) {
  const { t } = useTranslation('navigation');
  const classes = useStyles();
  const [Search, setSearch] = React.useState('');
  const location = useLocation();
  const SessionUser = getUser();
  const [menuItems, setMenuItems] = useState([]);

  const Menu = NavConfig();


  const MenuCount = Menu?.length;
  const { oktaAuth, authState } = useOktaAuth();



  useEffect(() => {
    if (SessionUser.TechnicianType === undefined) {
      return;
    }
    const user_types = SessionUser.TechnicianType.split(',');
    user_types && user_types.forEach((u) => {
      if (parseInt(u) === 26) {
        klima_teknisyeni = true;
      }
    });
  }, [SessionUser]);

  const [UserImageUrl, setUserImageUrl] = useState(!isProduction ? avatar : `https://yetkiliservis.arcelik.com/SchedulingQuota/TechnicianImage/${SessionUser.TechnicianId}.png`);



  useEffect(() => {
    GetSiriusUserImage();
  }, [SessionUser.TechnicianId]);

  const GetSiriusUserImage = () => {
    const config = {
      responseType: 'blob',
    };

    axios.get(`/FileImportExport/SiriusUserImageDetail/${SessionUser.TechnicianId}`, config)
      .then((response) => {
        // openBlob(response.data, dosya.FileName);
        const fileURL = URL.createObjectURL(response.data);
        setUserImageUrl(fileURL);
      }).catch((error) => {

      });
  }

  const content = (
    <div {...rest} className={clsx(classes.root, className)}>
      <br />
      <Divider className={classes.divider} />
      <nav>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder={t('lblSearchMenu')}
            autoFocus
            value={Search}
            // onKeyUp={(e) => setAnchorEl(e.currentTarget)}
            onChange={(event) => setSearchFind(event)}
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ 'aria-label': 'search' }}
          />
        </div>
      </nav>
      <Divider className={classes.divider} />
      <nav className={classes.navigation}>
        {menuItems.length === 0 ? (Menu && Menu.length > 0) && Menu.map(list =>
          renderNavItems(
            {
              items: list.items,
              subheader: list.subheader,
              pathname: location.pathname,
              key: list.subheader
            },
            klima_teknisyeni
          )
        ) : (menuItems && menuItems.length > 0) && menuItems.map(list =>
          renderNavItems(
            {
              items: list.items,
              subheader: list.subheader,
              pathname: location.pathname,
              key: list.subheader
            },
            klima_teknisyeni
          )
        )}
      </nav>
      <Divider className={classes.divider} />
      <div className={classes.profile}>
        <Avatar
          alt="Person"
          className={classes.avatar}
          src={UserImageUrl}
        />
        <div className={classes.details}>
          <Link
            component={RouterLink}
            to="/profile/1/timeline"
            variant="h5"
            color="textPrimary"
            underline="none"
          >
            {`${SessionUser.FirstName} ${SessionUser.LastName}`}
          </Link>
          <Typography variant="body2">
            {SessionUser.ServiceShopCode}
            {' '}
            {SessionUser.ServiceShopName}
            {' '}
            {SessionUser.TopServiceShopName}
          </Typography>
        </div>
      </div>
    </div>
  );

  const setSearchFind = (event) => {
    setSearch(event.target.value);
    var SearchDataEnd = Menu[0].items.filter((item) => sc(item.title, event.target.value));
    var result = [
      {
        subheader: t('Menus'),
        items: SearchDataEnd
      }
    ];
    setMenuItems(result);

  }




  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.mobileDrawer
          }}
          onClose={onClose}
          open={open}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{
            paper: classes.desktopDrawer
          }}
          open={open}
          onClose={onClose}
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

NavBar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

export default NavBar;
